// import My from '@/view/my/Index.vue'
import { NativeTabNavigatoLayout } from '@/layout'
import Case from '@/view/case/Index.vue'


const routes = [
  {
    path: '/nativeTab',
    component: NativeTabNavigatoLayout,
    children: [
      {
        path: 'case',
        name: 'case',
        // component: () => import('@/view/case/Index.vue')
        component: Case,
      },
    ]
  },
  // {
  //   path: '/case',
  //   name: 'case',
  //   component: () => import('@/view/case/Index.vue')
  // },
  {
    path: '/case/details/:id',
    name: '/case/details',
    component: () => import('@/view/case/Details.vue')
  },
]

export default { routes }